module.exports = __webpack_public_path__ + "img/Primordial-Process-7.e0ef8c47.png";